import { Component, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconRegistry, MatIcon } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SnackbarConfig } from '../../types/snackbar';

@Component({
  selector: 'app-snackbar-mini',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './snackbar-mini.html',

})
export class SnackbarMiniComponent {
  config = input<SnackbarConfig>({
    type: 'info',
    message: '',
    icon: 'info-icon.svg',
  });

  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.iconRegistry.addSvgIcon(
      'success-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/check_icon.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'error-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/error_icon.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'info-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/info_icon.svg'),
    );
  }

  getBackgroundColor(): string {
    switch (this.config().type) {
      case 'success':
        return '#E7F6EA';
      case 'error':
        return '#FFE7E8';
      case 'info':
        return '#F5F5F5';
      default:
        return '#F5F5F5';
    }
  }

  getIcon(): string {
    switch (this.config().type) {
      case 'success':
        return 'success-icon';
      case 'error':
        return 'error-icon';
      case 'info':
        return 'info-icon';
      default:
        return 'info-icon';
    }
  }

  getTextColor(): string {
    switch (this.config().type) {
      case 'success':
        return '#005F15';
      case 'error':
        return '#F00444';
      case 'info':
        return '#555555';
      default:
        return '#555555';
    }
  }

  getIconColor(): string {
    switch (this.config().type) {
      case 'success':
        return '#008218';
      case 'error':
        return '#F00444';
      case 'info':
        return '#0057FF';
      default:
        return '#0057FF';
    }
  }
}
